import { render } from "./NFTInfo.vue?vue&type=template&id=7e70c5b8"
import script from "./NFTInfo.vue?vue&type=script&lang=js"
export * from "./NFTInfo.vue?vue&type=script&lang=js"

import "./NFTInfo.vue?vue&type=style&index=0&id=7e70c5b8&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/testnet.onegate/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__